module.exports = __webpack_public_path__ + "img/houtai_yonghushuju.9e0686b8.png";